var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAscendingHoverIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3641",
    "data-name": "Group 3641",
    transform: "translate(-456 -1037)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1528",
    "data-name": "Rectangle 1528",
    width: 12,
    height: 12,
    rx: 2,
    transform: "translate(456 1037)",
    fill: "#227c9d",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "arrow_drop_down_FILL0_wght400_GRAD0_opsz48",
    d: "M18.082,24.112,14,20.05h8.165Z",
    transform: "translate(444 1020.95)",
    fill: "#64686a"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAscendingHoverIcon);
export default __webpack_public_path__ + "static/media/AscendingHoverIcon.280e07e11c18848afb6dc6eab026b185.svg";
export { ForwardRef as ReactComponent };